import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { Section, VStack } from 'tio-ui/components/layout';
import Text from 'tio-reimagined/components/text';
import Switch from 'tio-reimagined/components/switch';
import type BetaExperienceService from 'tio-employee/services/beta-experience';

/**
 * Beta Features section for the Profile page.
 *
 * Shows a toggle to opt in to beta-quality features that have graduated
 * from alpha (/reimagined/*) into the main templates. Only visible when
 * the `betaExperience` feature flag is enabled (non-production envs).
 */
export default class BetaFeaturesSection extends Component {
  @service declare betaExperience: BetaExperienceService;

  handleToggle = (checked: boolean) => {
    this.betaExperience.setEnabled(checked);
  };

  <template>
    {{#if this.betaExperience.flagEnabled}}
      <Section>
        <:header>{{t "profile.beta.title"}}</:header>
        <:body>
          <VStack class="gap-4">
            <Text @variant="muted" @size="sm">
              {{t "profile.beta.description"}}
            </Text>
            <Switch
              @label={{t "profile.beta.toggle_label"}}
              @hint={{t "profile.beta.toggle_hint"}}
              @checked={{this.betaExperience.isEnabled}}
              @onChange={{this.handleToggle}}
            />
          </VStack>
        </:body>
      </Section>
    {{/if}}
  </template>
}
